import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { WEB_COMPONENT_GZ_INFO_BOX } from '../../../../webcomponents.constants';

export const templateCompanyAuthenticationTab = document.createElement('template');

templateCompanyAuthenticationTab.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>

    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='form-wrapper'>
      <${WEB_COMPONENT_GZ_INFO_BOX} class='hidden'></${WEB_COMPONENT_GZ_INFO_BOX}>
      <gz-company-authentication-form></gz-company-authentication-form>
    </div>

    <div class='bottom-buttons'>
      <gz-button id='save-button' disabled></gz-button>
      <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
    </div>
  </div>
`;
